export function formatContentTime(isoDate: string): string {
  const date = new Date(isoDate);
  const now = new Date();

  const diffMs = now.getTime() - date.getTime();
  const diffMin = diffMs / 1000 / 60;
  const diffHours = diffMin / 60;

  if (diffHours < 24) {
    if (diffMin < 1) return "Just now";
    if (diffMin < 60) return `${Math.floor(diffMin)} minutes ago`;
    return `${Math.floor(diffHours)} hours ago`;
  }

  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
  });
}
